import { createContext, useContext, ReactElement } from 'react';
import { useUrlParams } from '../../hooks/url/useUrlParams';

export const USER_ROLES = ['homeowner', 'installer', 'dealer'] as const;
export type UserRole = typeof USER_ROLES[number];

export interface RoleProps {
    role?: UserRole;
}

export const RoleContext = createContext<RoleProps>({
    role: undefined,
});

/**
 * use either the given role or the role from the url
 * @param children
 * @param role
 * @constructor
 */
export const RoleProvider = ({ children, role }: RoleProps & { children: ReactElement }) => {
    const { params } = useUrlParams();

    const urlRole = params.user;

    const _role = role ?? (params.user && USER_ROLES.includes(urlRole as UserRole) ? (urlRole as UserRole) : undefined);
    return <RoleContext.Provider value={{ role: _role }}>{children}</RoleContext.Provider>;
};

export const useRole = () => useContext(RoleContext);
